export default __webpack_public_path__ + "static/Merriweather-Regular-3c4aa33e3f8e0a2406922124107f16de.woff";